import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { APP_CONFIGS } from "../../_constants";
import { alertActions, userActions } from "../../_redux/actions";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { loginRequest } from "../../_helpers/authConfig";
import styles from './LoginPage.module.scss'
import { Button } from "@material-ui/core";
import { loginPageLogos, microfoftLogo} from "../../asset";
import { AuthorizedUserInfoDto } from "../../_models";

const LoginPage = () => {
  const dispatch = useDispatch();
  const history = useHistory()
  const { instance, accounts } = useMsal()
  const isAuthenticated = useIsAuthenticated()

  const userDetail = useSelector((state: any) => state.users.userDetail)
  React.useEffect(() => {
    if (isAuthenticated) {
      if (accounts[0]) {
        dispatch(userActions.authorizeUser(accounts[0].username, (res) => {
          // store user data in storage
          const user: AuthorizedUserInfoDto = {
            id: res.id,
            firstName: res.firstName,
            lastName: res.lastName,
            tulitaLicenseNo: res.tulitaLicenseNo,
            userEmail: res.userEmail,
            isActive: res.isActive,
            isAdmin: false,
            roles: res.userRoles
          }
          if (!!res.userRoles && res.userRoles.length > 0) {
            user.isAdmin = !!res.userRoles.find(r => r.name.toUpperCase() === APP_CONFIGS.ADMIN_IDENTIFIER)
          }

          sessionStorage.setItem(APP_CONFIGS.USER_SESSION_KEY, btoa(JSON.stringify(user)))
          localStorage.setItem(APP_CONFIGS.USER_FACTORIES_SESSION_KEY, btoa(JSON.stringify(res.userFactories)))
          history.push('/')
        }, (error) => {
          dispatch(alertActions.triggerAlert(true, error as string, 'error'))
          // history.push('/')
        }))
        instance.setActiveAccount(accounts[0])
      }
    }
  }, [isAuthenticated])

  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch(e => {
      dispatch(alertActions.triggerAlert(true, e as string, 'error'))
    })
  }

  return (
    <React.Fragment>
      <div className={styles.loginWrapper}>
        <div className={styles.contentWrapper}>
          <div className={styles.contents}>
            <img className={styles.logo} src={loginPageLogos} />
            <h1 className={styles.title}>Hello !</h1>
            <h2 className={styles.subTitle}>Welcome to, <strong>Clock</strong></h2>
            <Button
              variant='contained'
              color='default'
              className={styles.loginBtn}
              disabled={userDetail.isLoading}
              onClick={handleLogin}
            >
              <img className={styles.msloginlogo} src={microfoftLogo} />
              Sign in with Microsoft
            </Button>
          </div>
        </div>

        <div className={styles.loginImage}></div>
      </div>
    </React.Fragment>
  );
};

export default LoginPage;
